import { StorageHelper } from './../helpers/StorageHelper';
import { InternationalizationHelper } from '../helpers/InternationalizationHelper';

export class Global {
  static ON_SALE = 'onsale';
  static CHARTS = 'charts';
  static MY_PURCHASES = 'my-purchases';
  static SPECIAL_LISTS = 'special-lists';
  static BLOCKLIST = "blocklist";
  static BUYMOVIES = 'buymovies';
  static RENTALMOVIES = 'rentalmovies';
  static SEASONS = 'seasons';
  static MOVIES = 'movies';
  static TV = 'tv';
  static MUSIC = 'music';
  static ALBUMS = 'albums';
  static SINGLES = 'singles';
  static AUDIOBOOKS = 'audiobooks';
  static EBOOKS = 'ebooks';
  static APPS = 'apps';
  static MACAPPS = 'macapps';
  static LATEST_PRICE_CHANGE = 'latestPricechange';
  static POPULARITY = 'popularity';
  static UPGRADE_DATE = 'turned4K';
  static UPGRADE_DATE_3D = 'turned3D';
  static PRICE = 'price';
  static RELEASE_DATE = 'releaseDate';
  static GREATEST_SAVINGS = 'greatestSavings';
  static GREATEST_PERCENTAGE_SAVINGS = 'greatestPercentageSavings';
  static RANK = 'rank';
  static ALPHABETICAL = 'alphabetical';
  static ADDED_TO_OWNLIST_AT = 'addedToOwnlistAt';
  static ADDED_TO_BLOCKLIST_AT = 'addedToBlocklistAt';
  static IMDB_RATING = 'imdbRating';
  static ROTTEN_RATING = 'rottenRating';
  static LETTERBOXD_RATING = 'letterboxdRating';
  static BUNDLE_SAVINGS = 'bundleSavings';
  static PRICE_PER_ITEM = 'pricePerItem';
  static PRICE_PER_MOVIE = 'pricePerMovie';
  static PRICE_PER_SEASON = 'pricePerSeason';
  static APP_RATING = 'appRating';
  static AZ = 'a-z';
  static MOVIES_4K = '4KMovies';
  static UPGRADED_4K = '4KUpgraded';
  static BUNDLES = 'bundles';
  static IMDBTOP250 = 'imdbtop250';
  static PREORDER = 'preorder';
  static RECENTLYADDED = 'recentlyadded';
  static NOW_FREE = 'nowfree';
  static GREATESTHITS = 'greatesthits';
  static JUST_RELEASED = 'justreleased';
  static NEW_ON_PRIME_VIDEO = 'new-on-prime-video';
  static BLACK_FRIDAY = 'blackFriday';
  static VISION_PRO_APPS = 'vision-pro-apps';
  static MOVIES_3D = '3dmovies';

  // static TOP_200 = 'top-200'; // Temporarily disabled
  static COMING_SOON = 'coming-soon';
  static NEW_RELEASES = 'new-releases';
  static NEW_MOVIES = 'new-movies';
  static MOVIES_IN_4K = '4k';
  static NEW_TO_4K = 'new-to-4k';
  static NEW_SEASONS = 'new-seasons';
  static SEASONS_IN_4K = '4k-seasons';
  static CLASSIC_SEASONS = 'classic-seasons';

  static DEVICE_TYPE_ALL = '0';
  static DEVICE_TYPE_IPHONE = '1';
  static DEVICE_TYPE_IPAD = '2';
  static DEVICE_TYPE_MAC = '3';
  static DEVICE_TYPE_VISION_PRO = '4';
  static DEVICE_TYPE_VISION_PRO_ONLY = '5';
  static DEVICE_IPHONE = 'iPhone';
  static DEVICE_IPAD = 'iPad';
  static DEVICE_VISION_PRO = 'Vision Pro';
  static DEVICE_VISION_PRO_ONLY = 'Vision Pro Only';

  static PRICE_FREE = 'free';
  static PRICE_TYPE_FREE = '0';
  static PRICE_PAID = 'paid';
  static PRICE_TYPE_PAID = '1';

  static ITUNES = 'itunes';
  static AMAZON = 'amazon';
  static VUDU = 'vudu';
  static GOOGLEPLAY = 'googlePlay';
  static DEFAULT_STORE: string = Global.ITUNES;
  static DEFAULT_COUNTRY = 'us';
  static DEFAULT_MEDIA_TYPE: string = Global.BUYMOVIES;

  static APP_ENTITY_MAIN_WEBSITE = "cc_main_website";

  static countryIconsBasePath = './assets/images/flags/';
  static supportedStores = ['itunes', 'amazon', 'vudu', 'googlePlay'];
  static countries = {
    de: { lang: "de", key: 'de', currency: 'EUR', string: 'germany', icon: Global.countryIconsBasePath + 'Germany.png' },
    us: { lang: "en", key: 'us', currency: 'USD', string: 'usa', icon: Global.countryIconsBasePath + 'USA.png' },
    au: { lang: "en", key: 'au', currency: 'AUD', string: 'australia', icon: Global.countryIconsBasePath + 'Australia.png' },
    at: { lang: "de", key: 'at', currency: 'EUR', string: 'austria', icon: Global.countryIconsBasePath + 'Austria.png' },
    ca: { lang: "en", key: 'ca', currency: 'CAD', string: 'canada', icon: Global.countryIconsBasePath + 'Canada.png' },
    cn: { lang: "en", key: 'cn', currency: 'CNY', string: 'china', icon: Global.countryIconsBasePath + 'China.png' },
    fr: { lang: "fr", key: 'fr', currency: 'EUR', string: 'france', icon: Global.countryIconsBasePath + 'France.png' },
    gb: { lang: "en", key: 'gb', currency: 'GBP', string: 'uk', icon: Global.countryIconsBasePath + 'UnitedKingdom.png' },
    in: { lang: "en", key: 'in', currency: 'INR', string: 'india', icon: Global.countryIconsBasePath + 'India.png' },
    jp: { lang: "en", key: 'jp', currency: 'JPY', string: 'japan', icon: Global.countryIconsBasePath + 'Japan.png' },
    pl: { lang: "en", key: 'pl', currency: 'PLN', string: 'poland', icon: Global.countryIconsBasePath + 'Poland.png' },
    pt: { lang: "en", key: 'pt', currency: 'EUR', string: 'portugal', icon: Global.countryIconsBasePath + 'Portugal.png' },
    ru: { lang: "en", key: 'ru', currency: 'RUB', string: 'russia', icon: Global.countryIconsBasePath + 'Russia.png' },
    es: { lang: "es", key: 'es', currency: 'EUR', string: 'spain', icon: Global.countryIconsBasePath + 'Spain.png' },
    ch: { lang: "de", key: 'ch', currency: 'CHF', string: 'switzerland', icon: Global.countryIconsBasePath + 'Switzerland.png' },
    tr: { lang: "en", key: 'tr', currency: 'TRY', string: 'turkey', icon: Global.countryIconsBasePath + 'Turkey.png' },
    br: { lang: "en", key: 'br', currency: 'USD', string: 'brazil', icon: Global.countryIconsBasePath + 'Brazil.png' },
    nl: { lang: "en", key: 'nl', currency: 'EUR', string: 'netherlands', icon: Global.countryIconsBasePath + 'Netherlands.png' },
    dk: { lang: "en", key: 'dk', currency: 'DKK', string: 'denmark', icon: Global.countryIconsBasePath + 'Denmark.png' },
    se: { lang: "en", key: 'se', currency: 'SEK', string: 'sweden', icon: Global.countryIconsBasePath + 'Sweden.png' },
    be: { lang: "fr", key: 'be', currency: 'EUR', string: 'belgium', icon: Global.countryIconsBasePath + 'Belgium.png' },
    it: { lang: "en", key: 'it', currency: 'EUR', string: 'italy', icon: Global.countryIconsBasePath + 'Italy.png' },
    ie: { lang: "en", key: 'ie', currency: 'EUR', string: 'ireland', icon: Global.countryIconsBasePath + 'Ireland.png' },
    mx: { lang: "es", key: 'mx', currency: 'MXN', string: 'mexico', icon: Global.countryIconsBasePath + 'Mexico.png' },
    nz: { lang: "en", key: 'nz', currency: 'NZD', string: 'newZealand', icon: Global.countryIconsBasePath + 'NewZealand.png' },
    fi: { lang: "en", key: 'fi', currency: 'EUR', string: 'finland', icon: Global.countryIconsBasePath + 'Finland.png' },
    sg: { lang: "en", key: 'sg', currency: 'SGD', string: 'singapore', icon: Global.countryIconsBasePath + 'Singapore.png' }
  };

  static mediaMatrix = {
    de: { music: true, movies: true, seasons: true, audiobooks: true, ebooks: true, apps: true, macapps: true },
    us: { music: true, movies: true, seasons: true, audiobooks: true, ebooks: true, apps: true, macapps: true },
    gb: { music: true, movies: true, seasons: true, audiobooks: true, ebooks: true, apps: true, macapps: true },
    ru: { music: true, movies: true, seasons: false, audiobooks: false, ebooks: false, apps: false, macapps: false },
    jp: { music: true, movies: false, seasons: false, audiobooks: false, ebooks: false, apps: false, macapps: false },
    fr: { music: true, movies: true, seasons: true, audiobooks: true, ebooks: true, apps: true, macapps: true },
    au: { music: true, movies: true, seasons: true, audiobooks: true, ebooks: true, apps: true, macapps: true },
    tr: { music: true, movies: true, seasons: false, audiobooks: false, ebooks: false, apps: false, macapps: false },
    pt: { music: true, movies: true, seasons: false, audiobooks: false, ebooks: false, apps: false, macapps: false },
    pl: { music: true, movies: false, seasons: false, audiobooks: false, ebooks: false, apps: false, macapps: false },
    ch: { music: true, movies: true, seasons: false, audiobooks: true, ebooks: true, apps: true, macapps: true },
    in: { music: true, movies: true, seasons: false, audiobooks: false, ebooks: false, apps: false, macapps: false },
    at: { music: true, movies: true, seasons: false, audiobooks: true, ebooks: true, apps: true, macapps: true },
    es: { music: true, movies: true, seasons: false, audiobooks: false, ebooks: false, apps: false, macapps: false },
    ca: { music: true, movies: true, seasons: true, audiobooks: true, ebooks: true, apps: true, macapps: true },
    cn: { music: true, movies: false, seasons: false, audiobooks: false, ebooks: false, apps: true, macapps: true },
    br: { music: true, movies: true, seasons: false, audiobooks: false, ebooks: true, apps: true, macapps: false },
    nl: { music: true, movies: true, seasons: false, audiobooks: true, ebooks: true, apps: true, macapps: false },
    dk: { music: true, movies: true, seasons: false, audiobooks: true, ebooks: true, apps: true, macapps: false },
    it: { music: false, movies: true, seasons: false, audiobooks: false, ebooks: false, apps: false, macapps: false },
    se: { music: false, movies: true, seasons: false, audiobooks: false, ebooks: false, apps: false, macapps: false },
    be: { music: false, movies: true, seasons: false, audiobooks: false, ebooks: false, apps: false, macapps: false },
    ie: { music: false, movies: true, seasons: false, audiobooks: false, ebooks: false, apps: false, macapps: false },
    mx: { music: false, movies: true, seasons: false, audiobooks: false, ebooks: false, apps: false, macapps: false },
    nz: { music: false, movies: true, seasons: false, audiobooks: false, ebooks: false, apps: false, macapps: false },
    fi: { music: false, movies: true, seasons: false, audiobooks: false, ebooks: false, apps: false, macapps: false },
    sg: { music: false, movies: true, seasons: false, audiobooks: false, ebooks: false, apps: false, macapps: false }
  };

  static supportedCountries = {
    itunes: Global.countries,
    amazon: { us: Global.countries.us, de: Global.countries.de },
    vudu: { us: Global.countries.us },
    googlePlay: { us: Global.countries.us }
  };
  static supportedMediaTypes = {
    itunes: [Global.BUYMOVIES, Global.RENTALMOVIES, 'albums', 'singles', 'seasons', 'apps', 'ebooks', 'audiobooks', 'macapps'],
    amazon: [Global.BUYMOVIES, Global.RENTALMOVIES, 'seasons'],
    vudu: [Global.BUYMOVIES, Global.RENTALMOVIES, 'seasons'],
    googlePlay: [Global.BUYMOVIES, Global.RENTALMOVIES]
  };

  static mediaTypesForSelector = {
    itunes: ['movies', 'seasons', 'music' , 'audiobooks', 'ebooks', 'apps', 'macapps'],
    amazon: ['movies', 'seasons'],
    vudu: ['movies', 'seasons'],
    googlePlay: ['movies']
  };

  static mediaTypesForSearch = {
    itunes: ['all', 'movies', 'seasons', 'albums', 'singles', 'audiobooks', 'ebooks', 'apps', 'macapps'],
    amazon: ['all', 'movies', 'seasons'],
    vudu: ['all', 'movies', 'seasons'],
    googlePlay: ['all', 'movies']
  };

  static mediaTypesForSearchSelector = {
    itunes: ['movies', 'seasons', 'albums', 'singles', 'audiobooks', 'ebooks', 'apps', 'macapps'],
    amazon: ['movies', 'seasons'],
    vudu: ['movies', 'seasons'],
    googlePlay: ['movies']
  };

  static supportedDetailViewMediaTypes = ['movies', 'albums', 'singles', 'seasons', 'apps', 'ebooks', 'audiobooks', 'macapps'];
  static supportedWishlistMediaTypes = ['movies', 'seasons', 'tv', 'music', 'apps', 'ebooks', 'audiobooks', 'macapps'];

static getCorrespondingMediaType(mediaTypeUrl: string) {
  switch(mediaTypeUrl) {
    case "movies":
    case "filme":
    case "films":
    case "peliculas":
      return Global.MOVIES;
    case "seasons":
    case "serien":
    case "series":
    case "temporadas":
      return Global.SEASONS;
    case "tv":
      return Global.TV;
    case "music":
    case "musik":
    case "musique":
    case "musica":
      return Global.MUSIC
    case "albums":
    case "alben":
    case "albumes":
      return Global.ALBUMS;
    case "singles":
    case "sencillos":
      return Global.SINGLES;
    case "ebooks":
    case "buecher":
    case "livres":
      return Global.EBOOKS;
    case "audiobooks":
    case "hoerbuecher":
    case "livres-audio":
    case "audiolibros":
      return Global.AUDIOBOOKS;
    case "apps":
    case "applis":
      return Global.APPS;
    case "macapps":
    case "applis-mac":
    case "aplicaciones-mac":
      return Global.MACAPPS;
    default:
      return null;
  }
}

  static sortingMatrix = {
    movies_onsale: [Global.LATEST_PRICE_CHANGE, Global.POPULARITY, Global.PRICE, Global.RELEASE_DATE, Global.GREATEST_SAVINGS, Global.GREATEST_PERCENTAGE_SAVINGS, Global.IMDB_RATING, Global.ROTTEN_RATING],
    movies_charts: [Global.RANK, Global.LATEST_PRICE_CHANGE, Global.POPULARITY, Global.PRICE, Global.RELEASE_DATE, Global.GREATEST_SAVINGS, Global.GREATEST_PERCENTAGE_SAVINGS, Global.IMDB_RATING, Global.ROTTEN_RATING],
    music_onsale: [Global.LATEST_PRICE_CHANGE, Global.POPULARITY, Global.PRICE, Global.RELEASE_DATE, Global.GREATEST_SAVINGS, Global.GREATEST_PERCENTAGE_SAVINGS ],
    music_charts: [Global.RANK, Global.LATEST_PRICE_CHANGE, Global.POPULARITY, Global.PRICE, Global.RELEASE_DATE, Global.GREATEST_SAVINGS, Global.GREATEST_PERCENTAGE_SAVINGS ],
    seasons_onsale: [Global.LATEST_PRICE_CHANGE, Global.POPULARITY, Global.PRICE, Global.RELEASE_DATE, Global.GREATEST_SAVINGS, Global.GREATEST_PERCENTAGE_SAVINGS ],
    seasons_charts: [Global.RANK, Global.LATEST_PRICE_CHANGE, Global.POPULARITY, Global.PRICE, Global.RELEASE_DATE, Global.GREATEST_SAVINGS, Global.GREATEST_PERCENTAGE_SAVINGS ],
    audiobooks_onsale: [Global.LATEST_PRICE_CHANGE, Global.POPULARITY, Global.PRICE, Global.RELEASE_DATE, Global.GREATEST_SAVINGS, Global.GREATEST_PERCENTAGE_SAVINGS ],
    audiobooks_charts: [Global.RANK, Global.LATEST_PRICE_CHANGE, Global.POPULARITY, Global.PRICE, Global.RELEASE_DATE, Global.GREATEST_SAVINGS, Global.GREATEST_PERCENTAGE_SAVINGS ],
    books_onsale: [Global.LATEST_PRICE_CHANGE, Global.POPULARITY, Global.PRICE, Global.RELEASE_DATE, Global.GREATEST_SAVINGS, Global.GREATEST_PERCENTAGE_SAVINGS ],
    books_charts: [Global.RANK, Global.LATEST_PRICE_CHANGE, Global.POPULARITY, Global.PRICE, Global.RELEASE_DATE, Global.GREATEST_SAVINGS, Global.GREATEST_PERCENTAGE_SAVINGS ],
    apps_onsale: [Global.LATEST_PRICE_CHANGE, Global.POPULARITY, Global.PRICE, Global.RELEASE_DATE, Global.GREATEST_SAVINGS, Global.GREATEST_PERCENTAGE_SAVINGS ],
    apps_charts: [Global.RANK, Global.LATEST_PRICE_CHANGE, Global.POPULARITY, Global.PRICE, Global.RELEASE_DATE, Global.GREATEST_SAVINGS, Global.GREATEST_PERCENTAGE_SAVINGS ],
    macapps_onsale: [Global.LATEST_PRICE_CHANGE, Global.POPULARITY, Global.PRICE, Global.RELEASE_DATE, Global.GREATEST_SAVINGS, Global.GREATEST_PERCENTAGE_SAVINGS ],
    macapps_charts: [Global.RANK, Global.LATEST_PRICE_CHANGE, Global.POPULARITY, Global.PRICE, Global.RELEASE_DATE, Global.GREATEST_SAVINGS, Global.GREATEST_PERCENTAGE_SAVINGS ]
  };

  static priceRanges = {
    buymovies: {
      de: [{ key: 'under', price: 4.00 },
      { key: 'between', price1: 4.00, price2: 6.00 },
      { key: 'between', price1: 6.00, price2: 9.00 },
      { key: 'between', price1: 9.00, price2: 13.00 },
      { key: 'over', price: 13.00 }],
      us: [{ key: 'under', price: 5.00 },
      { key: 'between', price1: 5.00, price2: 7.00 },
      { key: 'between', price1: 7.00, price2: 10.00 },
      { key: 'between', price1: 10.00, price2: 13.00 },
      { key: 'over', price: 13.00 }],
      gb: [{ key: 'under', price: 5.00 },
      { key: 'between', price1: 5.00, price2: 7.00 },
      { key: 'between', price1: 7.00, price2: 10.00 },
      { key: 'between', price1: 10.00, price2: 13.00 },
      { key: 'over', price: 13.00 }],
      ca: [{ key: 'under', price: 5.00 },
      { key: 'between', price1: 5.00, price2: 7.00 },
      { key: 'between', price1: 7.00, price2: 10.00 },
      { key: 'between', price1: 10.00, price2: 13.00 },
      { key: 'over', price: 13.00 }],
      ru: [{ key: 'under', price: 130.00 },
      { key: 'between', price1: 130.00, price2: 150.00 },
      { key: 'between', price1: 150.00, price2: 200.00 },
      { key: 'between', price1: 200.00, price2: 300.00 },
      { key: 'over', price: 300.00 }],
      dk: [{ key: 'under', price: 40.00 },
      { key: 'between', price1: 40.00, price2: 60.00 },
      { key: 'between', price1: 60.00, price2: 100.00 },
      { key: 'between', price1: 100.00, price2: 140.00 },
      { key: 'over', price: 140.00 }],
      mx: [{ key: 'under', price: 40.00 },
      { key: 'between', price1: 40.00, price2: 80.00 },
      { key: 'between', price1: 80.00, price2: 120.00 },
      { key: 'between', price1: 120.00, price2: 170.00 },
        { key: 'over', price: 170.00 }],
      tr: [{ key: 'under', price: 50.00 },
      { key: 'between', price1: 50.00, price2: 100.00 },
      { key: 'between', price1: 100.00, price2: 200.00 },
      { key: 'between', price1: 200.00, price2: 400.00 },
      { key: 'over', price: 400.00 }]
    },
    rentalmovies: {
      de: [{ key: 'under', price: 1.00 },
      { key: 'between', price1: 1.00, price2: 2.00 },
      { key: 'between', price1: 2.00, price2: 5.00 },
      { key: 'over', price: 5.00 }],
      us: [{ key: 'under', price: 1.00 },
      { key: 'between', price1: 1.00, price2: 2.00 },
      { key: 'between', price1: 2.00, price2: 5.00 },
      { key: 'over', price: 5.00 }],
      gb: [{ key: 'under', price: 1.00 },
      { key: 'between', price1: 1.00, price2: 2.00 },
      { key: 'between', price1: 2.00, price2: 5.00 },
      { key: 'over', price: 5.00 }],
      ca: [{ key: 'under', price: 1.00 },
      { key: 'between', price1: 1.00, price2: 2.00 },
      { key: 'between', price1: 2.00, price2: 5.00 },
      { key: 'over', price: 5.00 }],
      ru: [{ key: 'under', price: 130.00 },
      { key: 'between', price1: 130.00, price2: 150.00 },
      { key: 'over', price: 150.00 }],
      dk: [{ key: 'under', price: 30.00 },
      { key: 'between', price1: 30.00, price2: 40.00 },
      { key: 'over', price: 40.00 }],
      mx: [{ key: 'under', price: 21.00 },
      { key: 'between', price1: 21.00, price2: 30.00 },
      { key: 'between', price1: 30.00, price2: 51.00 },
      { key: 'between', price1: 51.00, price2: 61.00 },
        { key: 'over', price: 61.00 }],
      tr: [{ key: 'under', price: 20.00 },
      { key: 'between', price1: 20.00, price2: 50.00 },
      { key: 'between', price1: 50.00, price2: 80.00 },
      { key: 'between', price1: 80.00, price2: 160.00 },
      { key: 'over', price: 160.00 }]
    },
    moviesBundles: {
      de: [{key: 'under', price: 20.00},
          {key: 'between', price1: 20.00, price2: 30.00},
          {key: 'between', price1: 30.00, price2: 40.00},
          {key: 'between', price1: 40.00, price2: 70.00},
          {key: 'over', price: 70.00}],
      us: [{key: 'under', price: 25.00},
          {key: 'between', price1: 25.00, price2: 35.00},
          {key: 'between', price1: 35.00, price2: 50.00},
          {key: 'between', price1: 50.00, price2: 80.00},
          {key: 'over', price: 80.00}],
      gb: [{key: 'under', price: 25.00},
          {key: 'between', price1: 25.00, price2: 30.00},
          {key: 'between', price1: 30.00, price2: 40.00},
          {key: 'between', price1: 40.00, price2: 60.00},
          {key: 'over', price: 60.00}],
      ca: [{key: 'under', price: 40.00},
          {key: 'between', price1: 40.00, price2: 50.00},
          {key: 'between', price1: 50.00, price2: 80.00},
          {key: 'between', price1: 80.00, price2: 100.00},
          {key: 'over', price: 100.00}],
      ru: [{key: 'under', price: 600.00},
          {key: 'between', price1: 600.00, price2: 900.00},
          {key: 'between', price1: 900.00, price2: 1300.00},
          {key: 'over', price: 1300.00}],
      dk: [{key: 'under', price: 180.00},
          {key: 'between', price1: 180.00, price2: 250.00},
          {key: 'between', price1: 250.00, price2: 350.00},
          {key: 'between', price1: 350.00, price2: 500.00},
        { key: 'over', price: 500.00 }],
      mx: [{ key: 'under', price: 130.00 },
      { key: 'between', price1: 130.00, price2: 180.00 },
      { key: 'between', price1: 180.00, price2: 230.00 },
      { key: 'between', price1: 230.00, price2: 350.00 },
        { key: 'over', price: 350.00 }],
      tr: [{ key: 'under', price: 230.00 },
      { key: 'between', price1: 230.00, price2: 380.00 },
      { key: 'between', price1: 380.00, price2: 530.00 },
      { key: 'between', price1: 530.00, price2: 750.00 },
      { key: 'over', price: 750.00 }]
    },
    seasons: {
      de: [{key: 'under', price: 5.00},
          {key: 'between', price1: 5.00, price2: 10.00},
          {key: 'between', price1: 10.00, price2: 15.00},
          {key: 'between', price1: 15.00, price2: 20.00},
          {key: 'between', price1: 20.00, price2: 40.00},
          {key: 'over', price: 40.00}],
      us: [{key: 'under', price: 5.00},
          {key: 'between', price1: 5.00, price2: 10.00},
          {key: 'between', price1: 10.00, price2: 15.00},
          {key: 'between', price1: 15.00, price2: 20.00},
          {key: 'between', price1: 20.00, price2: 40.00},
          {key: 'over', price: 40.00}],
      gb: [{key: 'under', price: 5.00},
          {key: 'between', price1: 5.00, price2: 10.00},
          {key: 'between', price1: 10.00, price2: 15.00},
          {key: 'between', price1: 15.00, price2: 20.00},
          {key: 'between', price1: 20.00, price2: 40.00},
          {key: 'over', price: 40.00}],
      ca: [{key: 'under', price: 5.00},
          {key: 'between', price1: 5.00, price2: 10.00},
          {key: 'between', price1: 10.00, price2: 15.00},
          {key: 'between', price1: 15.00, price2: 20.00},
          {key: 'between', price1: 20.00, price2: 40.00},
          {key: 'over', price: 40.00}]
    },
    seasonsBundles: {
      de: [{key: 'under', price: 30.00},
          {key: 'between', price1: 30.00, price2: 50.00},
          {key: 'between', price1: 50.00, price2: 70.00},
          {key: 'between', price1: 70.00, price2: 100.00},
          {key: 'over', price: 100.00}],
      us: [{key: 'under', price: 30.00},
          {key: 'between', price1: 30.00, price2: 50.00},
          {key: 'between', price1: 50.00, price2: 70.00},
          {key: 'between', price1: 70.00, price2: 100.00},
          {key: 'over', price: 100.00}],
      gb: [{key: 'under', price: 30.00},
          {key: 'between', price1: 30.00, price2: 50.00},
          {key: 'between', price1: 50.00, price2: 70.00},
          {key: 'between', price1: 70.00, price2: 100.00},
          {key: 'over', price: 100.00}],
      ca: [{key: 'under', price: 30.00},
          {key: 'between', price1: 30.00, price2: 50.00},
          {key: 'between', price1: 50.00, price2: 70.00},
          {key: 'between', price1: 70.00, price2: 100.00},
          {key: 'over', price: 100.00}]
    },
    singles: {
      us: [{key: 'under', price: 1.29}],
      de: [{key: 'under', price: 1.29}],
      gb: [{key: 'for', price: 0.59},
          {key: 'for', price: 0.79},
          {key: 'for', price: 0.99}, ],
      ca: [{key: 'under', price: 1.29}]
    },
    albums: {
      us: [{key: 'under', price: 5.00},
          {key: 'between', price1: 5.00, price2: 10.00},
          {key: 'over', price: 10.00}],
      de: [{key: 'under', price: 5.00},
          {key: 'between', price1: 5.00, price2: 10.00},
          {key: 'over', price: 10.00}],
      gb: [{key: 'under', price: 5.00},
          {key: 'between', price1: 5.00, price2: 10.00},
          {key: 'over', price: 10.00}],
      ca: [{key: 'under', price: 5.00},
          {key: 'between', price1: 5.00, price2: 10.00},
          {key: 'over', price: 10.00}]
    },
    audiobooks: {
      us: [{key: 'under', price: 5.00},
          {key: 'between', price1: 5.00, price2: 10.00},
          {key: 'over', price: 10.00}],
      de: [{key: 'under', price: 5.00},
          {key: 'between', price1: 5.00, price2: 10.00},
          {key: 'over', price: 10.00}],
      gb: [{key: 'under', price: 5.00},
          {key: 'between', price1: 5.00, price2: 10.00},
          {key: 'over', price: 10.00}],
      ca: [{key: 'under', price: 5.00},
          {key: 'between', price1: 5.00, price2: 10.00},
          {key: 'over', price: 10.00}]
    },
    ebooks: {
      us: [{key: 'for', price: 0.99}, {key: 'for', price: 1.99},
          {key: 'under', price: 5.00},
          {key: 'between', price1: 5.00, price2: 10.00},
          {key: 'over', price: 10.00}],
      de: [{key: 'for', price: 0.99}, {key: 'for', price: 1.99},
          {key: 'under', price: 5.00},
          {key: 'between', price1: 5.00, price2: 10.00},
          {key: 'over', price: 10.00}],
      gb: [{key: 'for', price: 0.99}, {key: 'for', price: 1.99},
          {key: 'under', price: 5.00},
          {key: 'between', price1: 5.00, price2: 10.00},
          {key: 'over', price: 10.00}],
      ca: [{key: 'for', price: 0.99}, {key: 'for', price: 1.99},
          {key: 'under', price: 5.00},
          {key: 'between', price1: 5.00, price2: 10.00},
          {key: 'over', price: 10.00}]
    },
    apps: {
      us: [{key: 'under', price: 1.00},
          {key: 'for', price: 1.99},
          {key: 'for', price: 2.99},
          {key: 'between', price1: 3.00, price2: 5.00},
          {key: 'between', price1: 5.00, price2: 10.00},
          {key: 'between', price1: 10.00, price2: 15.00},
          {key: 'between', price1: 15.00, price2: 20.00},
          {key: 'over', price: 20.00}]
    },
    macapps: {
      us: [{key: 'under', price: 5.00},
          {key: 'between', price1: 5.00, price2: 10.00},
          {key: 'between', price1: 10.00, price2: 20.00},
          {key: 'between', price1: 20.00, price2: 30.00},
          {key: 'between', price1: 30.00, price2: 40.00},
          {key: 'over', price: 40.00}]
    }
  };

  static clearSaveUserInfos() {
    StorageHelper.getInstance().clear(StorageHelper.keys.sessionToken);
    StorageHelper.getInstance().clear(StorageHelper.keys.shortWishlist);
    StorageHelper.getInstance().clear(StorageHelper.keys.shortBlocklist);
    StorageHelper.getInstance().clear(StorageHelper.keys.shortOwnlist);
    StorageHelper.getInstance().clear(StorageHelper.keys.username);
    StorageHelper.getInstance().clear(StorageHelper.keys.email);
    StorageHelper.getInstance().clear(StorageHelper.keys.profileImageUrl);
    StorageHelper.getInstance().clear(StorageHelper.keys.uniqueCustomerId);
  }

  static getStore(): string {
    return StorageHelper.getInstance().get(StorageHelper.keys.store) || Global.DEFAULT_STORE;
  }

  static getStoreUrl(): string {
    let store = StorageHelper.getInstance().get(StorageHelper.keys.store) || Global.DEFAULT_STORE;
    if(store == Global.GOOGLEPLAY) {
      store = "google-play";
    }
    return store;
  }

  static getCountry(): string {
    let countryKey = StorageHelper.getInstance().get(StorageHelper.keys.country);
    if (!countryKey || Object.keys(Global.countries).indexOf(countryKey) == -1) {
      countryKey = Global.DEFAULT_COUNTRY;
    }

    return countryKey;
  }

  static ensureStoreIsSupported() {
    const store = Global.getStore();
    const country = Global.getCountry();
    const supportedCountriesForStore = Global.supportedCountries[store];

    if (!supportedCountriesForStore || !(country in supportedCountriesForStore)) {
      StorageHelper.getInstance().save(StorageHelper.keys.store, Global.ITUNES);
    }
  }

  static getMediaType(): string {
    return StorageHelper.getInstance().get(StorageHelper.keys.mediaType) || Global.DEFAULT_MEDIA_TYPE;
  }

  static getSchemaType(itemType?:string): string {

    const type = itemType ? itemType : Global.getMediaType();

    switch (type){
      case Global.MOVIES:
      case Global.BUYMOVIES:
      case Global.RENTALMOVIES:
      case 'movie':
        return 'Movie';
      case Global.SEASONS:
      case 'season':
        return 'CreativeWorkSeason';
      case Global.SINGLES:
      case 'single':
          return 'MusicRecording';
      case Global.ALBUMS:
      case 'album':
          return 'MusicAlbum';
      case Global.AUDIOBOOKS:
      case 'audiobook':
          return 'Audiobook';
      case Global.EBOOKS:
      case 'ebook':
        return 'Book';
      case Global.APPS:
      case 'app':
        return 'MobileApplication';
      case Global.MACAPPS:
      case 'macapp':
          return 'SoftwareApplication';
      default:
        return 'CreativeWork';
    }
  }

  static getMediaTypeForUrl(mType?:string): string {
    let mediaType = mType? mType : this.getMediaType();
    if(mediaType == Global.SINGLES || mediaType == Global.ALBUMS) {
      return mediaType = InternationalizationHelper.getString('musicUrl');
    }
    if(mediaType == Global.BUYMOVIES || mediaType == Global.RENTALMOVIES) {
      return mediaType = InternationalizationHelper.getString('moviesUrl');
    }
    return InternationalizationHelper.getString(mediaType + 'Url');
  }

  static getListType(): string {
    return StorageHelper.getInstance().get(StorageHelper.keys.listType);
  }

  static getStoreAndMediaTypeForLangFileSuffix(store?, mediaType?): string {
    if (mediaType == null) {
      mediaType = Global.getMediaType();
    }
    if (store == null) {
      store = Global.getStore();
    }

    if (mediaType == Global.BUYMOVIES || mediaType == Global.RENTALMOVIES) {
      mediaType = 'movies';
    }

    if (mediaType == 'albums' || mediaType == 'singles') {
      mediaType = 'music';
    }

    if (mediaType == "seasons") mediaType = "tv";
    if (mediaType == "macapps") mediaType = "MacApps";

    store = store.charAt(0).toUpperCase() + store.slice(1);
    mediaType = mediaType.charAt(0).toUpperCase() + mediaType.slice(1);

    return store + mediaType;

  }

  static getMediaTypeForSelector(mediaType?): string {
    if (mediaType == null){
      mediaType = Global.getMediaType();
    }
    if (mediaType == Global.BUYMOVIES || mediaType == Global.RENTALMOVIES){
      mediaType = 'movies';
    }
    else if (mediaType == 'albums' || mediaType == 'singles') {
      mediaType = 'music';
    }
    return mediaType;

  }

  static getBuyRent() {
    return StorageHelper.getInstance().get(StorageHelper.keys.buyRent);
  }

  static getMediaTypeFromItemItemType(itemType): string {

    if (itemType == 'movie'){
      return 'movies';
    }
    if (itemType == 'season'){
      return 'seasons';
    }
    if (itemType == 'album'){
      return 'albums';
    }
    if (itemType == 'song'){
      return 'singles';
    }
    if (itemType == 'audiobook'){
      return 'adiobooks';
    }
    if (itemType == 'ebook'){
      return 'ebooks';
    }
    if (itemType == 'app'){
      return 'apps';
    }
    if (itemType == 'macapp'){
      return 'macapps';
    }

    return Global.getMediaType();

  }

  static isStoreSupported(store: string) {
    //Check if the store is supported in the currently selected country
    const supportedCountries = Global.supportedCountries[store];
    if (supportedCountries && supportedCountries[Global.getCountry()] == null) {
      return false;
    }
    else {
      return true;
    }
  }

  static getGenreMediaType(mediaType): string {
    if (mediaType == Global.BUYMOVIES || mediaType == Global.RENTALMOVIES){
      mediaType = 'movies';
    }
    else if (mediaType == 'albums' || mediaType == 'singles') {
      mediaType = 'music';
    }
    else if (mediaType == 'seasons') {
      return 'tv';
    }
    return mediaType;
  }

  static getMediaTypeForDetailView(): string {
    let mediaType = Global.getMediaType();
    if (mediaType == Global.BUYMOVIES || mediaType == Global.RENTALMOVIES){
      mediaType = 'movies';
    }
    return mediaType;
  }

  /** Converts the item's itemType field into a mediaType */
  static getMediaTypeFromItemType(itemType: string): string {
    if (!itemType) {
      return '';
    }
    if (itemType == 'album' || itemType == 'single') {
      return 'music';
    }
    if (itemType == 'season') {
      return 'tv';
    }
    //Only single and album are special cases, the rest just has to be plural
    return Global.getPluralItemType(itemType);
  }

  /** The item only has a field "itemType" that is singular.
  For the wishlist, we need an "s" at the end. */
  static getPluralItemType(itemType: string): string {
    return (itemType) ? itemType + 's' : '';
  }

  static getMediaTypeForWishlistRequest(): string {
    let mediaType = Global.getMediaType();
    if (mediaType == Global.BUYMOVIES || mediaType == Global.RENTALMOVIES){
      mediaType = Global.MOVIES;
    }
    else if (mediaType == Global.ALBUMS || mediaType == Global.SINGLES) {
      mediaType = Global.MUSIC;
    }
    else if (mediaType == Global.SEASONS) {
      mediaType = Global.TV;
    }
    return mediaType;
  }

  static getItemTypeForWishList(media: string) {
    if(media == Global.MOVIES) { return Global.BUYMOVIES; }
    return media;
  }

  static getSpecialListsSortingValues(listType: string) {
    if (!listType) {
      return [];
    }

    const mediaType = Global.getMediaType();
    const store = Global.getStore();

    switch (listType){
      case 'a-z':
        const values = Global.getSortingValues(Global.ON_SALE);
        return values.concat(Global.ALPHABETICAL);
      case 'bundles':
        if (mediaType == Global.BUYMOVIES || mediaType == Global.RENTALMOVIES) {
          const baseSorting = [Global.LATEST_PRICE_CHANGE, Global.BUNDLE_SAVINGS, Global.PRICE_PER_MOVIE, Global.POPULARITY, Global.PRICE, Global.RELEASE_DATE,
            Global.ALPHABETICAL, Global.GREATEST_SAVINGS, Global.GREATEST_PERCENTAGE_SAVINGS];
          return baseSorting;
        }
        else {
          return [Global.LATEST_PRICE_CHANGE, Global.BUNDLE_SAVINGS, Global.PRICE_PER_SEASON, Global.POPULARITY, Global.PRICE, Global.RELEASE_DATE,
            Global.ALPHABETICAL, Global.GREATEST_SAVINGS, Global.GREATEST_PERCENTAGE_SAVINGS];
        }
      case 'imdbtop250':
        if (mediaType == Global.BUYMOVIES || mediaType == Global.RENTALMOVIES){
          const baseSorting = [Global.RANK, Global.LATEST_PRICE_CHANGE, Global.POPULARITY, Global.PRICE, Global.RELEASE_DATE, Global.ALPHABETICAL,
            Global.GREATEST_SAVINGS, Global.GREATEST_PERCENTAGE_SAVINGS, Global.IMDB_RATING, Global.ROTTEN_RATING];
          return store === Global.ITUNES ? [...baseSorting, Global.LETTERBOXD_RATING] : baseSorting;
        }
        return [Global.RANK, Global.LATEST_PRICE_CHANGE, Global.POPULARITY, Global.PRICE, Global.RELEASE_DATE, Global.ALPHABETICAL,
          Global.GREATEST_SAVINGS, Global.GREATEST_PERCENTAGE_SAVINGS];
      // case 'top-200': // Temporarily disabled
      //   if (mediaType == Global.BUYMOVIES || mediaType == Global.RENTALMOVIES) {
      //     const baseSorting = [Global.RANK, Global.LATEST_PRICE_CHANGE, Global.POPULARITY, Global.PRICE, Global.RELEASE_DATE, Global.ALPHABETICAL,
      //     Global.GREATEST_SAVINGS, Global.GREATEST_PERCENTAGE_SAVINGS, Global.IMDB_RATING, Global.ROTTEN_RATING];
      //     return store === Global.ITUNES ? [...baseSorting, Global.LETTERBOXD_RATING] : baseSorting;
      //   }
      //   return [Global.RANK, Global.LATEST_PRICE_CHANGE, Global.POPULARITY, Global.PRICE, Global.RELEASE_DATE, Global.ALPHABETICAL,
      //   Global.GREATEST_SAVINGS, Global.GREATEST_PERCENTAGE_SAVINGS];
      case 'coming-soon':
        if (mediaType == Global.BUYMOVIES || mediaType == Global.RENTALMOVIES) {
          const baseSorting = [Global.RELEASE_DATE, Global.LATEST_PRICE_CHANGE, Global.POPULARITY, Global.RANK, Global.PRICE, Global.ALPHABETICAL,
          Global.GREATEST_SAVINGS, Global.GREATEST_PERCENTAGE_SAVINGS, Global.IMDB_RATING, Global.ROTTEN_RATING];
          return store === Global.ITUNES ? [...baseSorting, Global.LETTERBOXD_RATING] : baseSorting;
        }
        return [Global.RELEASE_DATE, Global.LATEST_PRICE_CHANGE, Global.POPULARITY, Global.RANK, Global.PRICE, Global.ALPHABETICAL,
        Global.GREATEST_SAVINGS, Global.GREATEST_PERCENTAGE_SAVINGS];
      case 'new-releases':
        if (mediaType == Global.BUYMOVIES || mediaType == Global.RENTALMOVIES) {
          const baseSorting = [Global.RELEASE_DATE, Global.LATEST_PRICE_CHANGE, Global.POPULARITY, Global.RANK, Global.PRICE, Global.ALPHABETICAL,
          Global.GREATEST_SAVINGS, Global.GREATEST_PERCENTAGE_SAVINGS, Global.IMDB_RATING, Global.ROTTEN_RATING];
          return store === Global.ITUNES ? [...baseSorting, Global.LETTERBOXD_RATING] : baseSorting;
        }
        return [Global.RELEASE_DATE, Global.LATEST_PRICE_CHANGE, Global.POPULARITY, Global.RANK, Global.PRICE, Global.ALPHABETICAL,
        Global.GREATEST_SAVINGS, Global.GREATEST_PERCENTAGE_SAVINGS];
      case 'preorder':
      case 'recentlyadded':
      case 'justreleased':
      case 'new-on-prime-video':
        if (mediaType == Global.BUYMOVIES || mediaType == Global.RENTALMOVIES){
          const baseSorting = [Global.RELEASE_DATE, Global.LATEST_PRICE_CHANGE, Global.POPULARITY, Global.PRICE, Global.ALPHABETICAL,
            Global.GREATEST_SAVINGS, Global.GREATEST_PERCENTAGE_SAVINGS, Global.IMDB_RATING, Global.ROTTEN_RATING];
          return store === Global.ITUNES ? [...baseSorting, Global.LETTERBOXD_RATING] : baseSorting;
        }
        return [Global.RELEASE_DATE, Global.LATEST_PRICE_CHANGE, Global.POPULARITY, Global.PRICE, Global.ALPHABETICAL,
          Global.GREATEST_SAVINGS, Global.GREATEST_PERCENTAGE_SAVINGS];
      case 'nowfree':
        if (mediaType == Global.APPS || mediaType == Global.MACAPPS) {
          return [Global.LATEST_PRICE_CHANGE, Global.POPULARITY, Global.ALPHABETICAL, Global.RELEASE_DATE,
            Global.GREATEST_SAVINGS, Global.GREATEST_PERCENTAGE_SAVINGS];
        }
        const baseSorting = [Global.LATEST_PRICE_CHANGE, Global.POPULARITY, Global.ALPHABETICAL, Global.RELEASE_DATE,
          Global.GREATEST_SAVINGS, Global.GREATEST_PERCENTAGE_SAVINGS, Global.IMDB_RATING, Global.ROTTEN_RATING];
        return store === Global.ITUNES ? [...baseSorting, Global.LETTERBOXD_RATING] : baseSorting;
      case 'greatesthits':
        return [Global.LATEST_PRICE_CHANGE, Global.POPULARITY, Global.PRICE, Global.ALPHABETICAL, Global.RELEASE_DATE,
          Global.GREATEST_SAVINGS, Global.GREATEST_PERCENTAGE_SAVINGS];
      case '4KUpgraded':
        const baseSorting4K = [Global.UPGRADE_DATE, Global.LATEST_PRICE_CHANGE, Global.POPULARITY, Global.PRICE, Global.ALPHABETICAL,
        Global.RELEASE_DATE, Global.GREATEST_SAVINGS, Global.GREATEST_PERCENTAGE_SAVINGS, Global.IMDB_RATING, Global.ROTTEN_RATING];
        return store === Global.ITUNES ? [...baseSorting4K, Global.LETTERBOXD_RATING] : baseSorting4K;
      case '3dmovies':
        return [Global.UPGRADE_DATE_3D, Global.LATEST_PRICE_CHANGE, Global.POPULARITY, Global.PRICE, Global.ALPHABETICAL, Global.RELEASE_DATE,
          Global.GREATEST_SAVINGS, Global.GREATEST_PERCENTAGE_SAVINGS];
      case 'new-movies':
        if (mediaType == Global.BUYMOVIES || mediaType == Global.RENTALMOVIES) {
          const baseSorting = [Global.RELEASE_DATE, Global.LATEST_PRICE_CHANGE, Global.POPULARITY, Global.RANK, Global.PRICE, Global.ALPHABETICAL,
          Global.GREATEST_SAVINGS, Global.GREATEST_PERCENTAGE_SAVINGS, Global.IMDB_RATING, Global.ROTTEN_RATING];
          return store === Global.ITUNES ? [...baseSorting, Global.LETTERBOXD_RATING] : baseSorting;
        }
        return [Global.RELEASE_DATE, Global.LATEST_PRICE_CHANGE, Global.POPULARITY, Global.RANK, Global.PRICE, Global.ALPHABETICAL,
        Global.GREATEST_SAVINGS, Global.GREATEST_PERCENTAGE_SAVINGS];
      case '4k':
        if (mediaType == Global.BUYMOVIES || mediaType == Global.RENTALMOVIES) {
          const baseSorting = [Global.RANK, Global.LATEST_PRICE_CHANGE, Global.POPULARITY, Global.PRICE, Global.RELEASE_DATE, Global.ALPHABETICAL,
          Global.GREATEST_SAVINGS, Global.GREATEST_PERCENTAGE_SAVINGS, Global.IMDB_RATING, Global.ROTTEN_RATING];
          return store === Global.ITUNES ? [...baseSorting, Global.LETTERBOXD_RATING] : baseSorting;
        }
        return [Global.RANK, Global.LATEST_PRICE_CHANGE, Global.POPULARITY, Global.PRICE, Global.RELEASE_DATE, Global.ALPHABETICAL,
        Global.GREATEST_SAVINGS, Global.GREATEST_PERCENTAGE_SAVINGS];
      case 'new-to-4k':
        if (mediaType == Global.BUYMOVIES || mediaType == Global.RENTALMOVIES) {
          const baseSorting = [Global.RANK, Global.LATEST_PRICE_CHANGE, Global.POPULARITY, Global.PRICE, Global.RELEASE_DATE, Global.ALPHABETICAL,
          Global.GREATEST_SAVINGS, Global.GREATEST_PERCENTAGE_SAVINGS, Global.IMDB_RATING, Global.ROTTEN_RATING];
          return store === Global.ITUNES ? [...baseSorting, Global.LETTERBOXD_RATING] : baseSorting;
        }
        return [Global.RANK, Global.LATEST_PRICE_CHANGE, Global.POPULARITY, Global.PRICE, Global.RELEASE_DATE, Global.ALPHABETICAL,
        Global.GREATEST_SAVINGS, Global.GREATEST_PERCENTAGE_SAVINGS];
      case 'new-seasons':
        if (store === Global.VUDU) {
          return [Global.RANK, Global.RELEASE_DATE, Global.LATEST_PRICE_CHANGE, Global.POPULARITY, Global.PRICE, Global.ALPHABETICAL,
          Global.GREATEST_SAVINGS, Global.GREATEST_PERCENTAGE_SAVINGS];
        }
        return [Global.RELEASE_DATE, Global.LATEST_PRICE_CHANGE, Global.POPULARITY, Global.RANK, Global.PRICE, Global.ALPHABETICAL,
        Global.GREATEST_SAVINGS, Global.GREATEST_PERCENTAGE_SAVINGS];
      case '4k-seasons':
        return [Global.RANK, Global.LATEST_PRICE_CHANGE, Global.POPULARITY, Global.PRICE, Global.RELEASE_DATE, Global.ALPHABETICAL,
        Global.GREATEST_SAVINGS, Global.GREATEST_PERCENTAGE_SAVINGS];
      case 'classic-seasons':
        if (store === Global.VUDU) {
          return [Global.RANK, Global.LATEST_PRICE_CHANGE, Global.POPULARITY, Global.PRICE, Global.RELEASE_DATE, Global.ALPHABETICAL,
          Global.GREATEST_SAVINGS, Global.GREATEST_PERCENTAGE_SAVINGS];
        }
        return [Global.LATEST_PRICE_CHANGE, Global.POPULARITY, Global.PRICE, Global.RELEASE_DATE, Global.ALPHABETICAL,
        Global.GREATEST_SAVINGS, Global.GREATEST_PERCENTAGE_SAVINGS];
      default:
        return [Global.LATEST_PRICE_CHANGE, Global.POPULARITY, Global.PRICE, Global.ALPHABETICAL, Global.RELEASE_DATE,
          Global.GREATEST_SAVINGS, Global.GREATEST_PERCENTAGE_SAVINGS];
    }
  }

  static getSortingValues(listType: string) {
    const mediaType = Global.getMediaType();
    const store = Global.getStore();

    if (listType == Global.ON_SALE || listType == Global.CHARTS) {
      switch (mediaType){
        case Global.BUYMOVIES:
        case Global.RENTALMOVIES:
          const movieSorting = Global.sortingMatrix['movies_' + listType];
          return store === Global.ITUNES ? [...movieSorting, Global.LETTERBOXD_RATING] : movieSorting;
        case Global.SEASONS:
          return Global.sortingMatrix['seasons_' + listType];
        case Global.ALBUMS:
        case Global.SINGLES:
          return Global.sortingMatrix['music_' + listType];
        case Global.AUDIOBOOKS:
          return Global.sortingMatrix['audiobooks_' + listType];
        case Global.EBOOKS:
          return Global.sortingMatrix['books_' + listType];
        case Global.APPS:
          return Global.sortingMatrix['apps_' + listType];
        case Global.MACAPPS:
          return Global.sortingMatrix['macapps_' + listType];
        default:
          return [];
      }
    }
    else {
      return this.getSpecialListsSortingValues(listType);
    }
  }

  static getSortPeriodValues() {
    return ["all", "year", "month", "week", "day"];
  }

  static isUserKnown(): boolean {
    //Check if the user already visited the site.
    //If yes, the variable store should be present in the storage
    const storeInStorage = StorageHelper.getInstance().get(StorageHelper.keys.store);
    return storeInStorage != null;
  }

  static saveUserCountryLocal(res) {
    let countryCode = InternationalizationHelper.getCountry();

    if (res && res.country) {
      countryCode = res.country;

      //If the country of the user is not supported, use the default country
      if (Object.keys(Global.countries).indexOf(countryCode) == -1){
        countryCode = Global.DEFAULT_COUNTRY;
      }

    }
    StorageHelper.getInstance().save(StorageHelper.keys.country, countryCode);
  }

  static lists = [
    {
      store: Global.ITUNES, categories: [
      {title:"movies", color:"red", mediaType:Global.BUYMOVIES,
      items: [
        {title: 'blackFriday', icon:'list', listType: Global.BLACK_FRIDAY, url:InternationalizationHelper.getString('blackFridayDealsUrl') },
        {title: "onsale", icon:"list", listType: Global.ON_SALE, url: InternationalizationHelper.getString('onSaleUrl') },
        {title: "charts", icon:"list", listType: Global.CHARTS, url: "charts" },
        {title: "movieBundles", icon:"list", listType:Global.BUNDLES, url: InternationalizationHelper.getString('movieBundlesUrl')},
        {title: "movies4K", icon:"list", listType:Global.MOVIES_4K, url: InternationalizationHelper.getString('movie4kUrl')},
        {title: "upgradedTo4K", icon:"list", listType: Global.UPGRADED_4K, url: InternationalizationHelper.getString('upgradedTo4kUrl')},
        { title: "movies3D", icon: "list", listType: Global.MOVIES_3D, url: InternationalizationHelper.getString('movie3dUrl') },
        {title: "preorder", icon:"list", listType:Global.PREORDER, url: InternationalizationHelper.getString('preorderUrl')},
        {title: "allMovies", icon:"list", listType: Global.AZ, url: InternationalizationHelper.getString('allMoviesUrl')},
        {title: "justreleased", icon:"list", listType:Global.JUST_RELEASED, url: InternationalizationHelper.getString('justReleasedUrl')},
        { title: "newOnAppleTv", icon: "list", listType: Global.RECENTLYADDED, url: InternationalizationHelper.getString('newOniTunesUrl') },
        {title: "imdbTop250", icon:"list", listType:Global.IMDBTOP250, url: "/imdb-top-250"}]},

      {title:"seasons", color:"green", mediaType:Global.SEASONS,
      items: [
        {title: 'blackFriday', icon:'list', listType: Global.BLACK_FRIDAY, url:InternationalizationHelper.getString('blackFridayDealsUrl') },
        {title: "onsale", icon:"list", listType: Global.ON_SALE, url: InternationalizationHelper.getString('onSaleUrl') },
        {title: "charts", icon:"list", listType: Global.CHARTS, url: "charts" },
        {title: "tvBundles", icon:"list", listType:Global.BUNDLES, url: InternationalizationHelper.getString('seasonsBundlesUrl')},
        {title: "allSeasons", icon:"list", listType:Global.AZ, url: InternationalizationHelper.getString('allSeasonsUrl')},
            { title: "newOnAppleTv", icon: "list", listType: Global.RECENTLYADDED, url: InternationalizationHelper.getString('newOniTunesUrl') }]
        },

      {title:"apps", color:"darkblue", mediaType:Global.APPS,
      items: [
        {title: 'blackFriday', icon:'list', listType: Global.BLACK_FRIDAY, url:InternationalizationHelper.getString('blackFridayDealsUrl') },
        {title: "onsale", icon:"list", listType: Global.ON_SALE, url: InternationalizationHelper.getString('onSaleUrl') },
        {title: "charts", icon:"list", listType: Global.CHARTS, url: "charts" },
        {title: "allApps", icon:"list", listType:Global.AZ, url: InternationalizationHelper.getString('allAppsUrl')},
        { title: "allAppsVisionPro", icon: "list", listType: Global.VISION_PRO_APPS, url: InternationalizationHelper.getString('allAppsVisionProUrl') },
        {title: "currentlyForFree", icon:"list", listType:Global.NOW_FREE, url: InternationalizationHelper.getString('nowFreeUrl')},
        {title: "newInAppStore", icon:"list", listType:Global.RECENTLYADDED, url: InternationalizationHelper.getString('newOniTunesUrl')}]},

      {title:"macapps", color:"darkblue", mediaType:Global.MACAPPS,
      items: [
        {title: 'blackFriday', icon:'list', listType: Global.BLACK_FRIDAY, url:InternationalizationHelper.getString('blackFridayDealsUrl') },
        {title: "onsale", icon:"list", listType: Global.ON_SALE, url: InternationalizationHelper.getString('onSaleUrl') },
        {title: "charts", icon:"list", listType: Global.CHARTS, url: "charts" },
        {title: "allMacApps", icon:"list", listType:Global.AZ, url: InternationalizationHelper.getString('allMacAppsUrl')},
        {title: "currentlyForFree", icon:"list", listType:Global.NOW_FREE, url: InternationalizationHelper.getString('nowFreeUrl')},
        {title: "newInMacAppStore", icon:"list", listType:Global.RECENTLYADDED, url: InternationalizationHelper.getString('newOniTunesUrl')}]},

      {title:"music", color:"lila", mediaType:Global.ALBUMS,
      items: [
        {title: 'blackFriday', icon:'list', listType: Global.BLACK_FRIDAY, url:InternationalizationHelper.getString('blackFridayDealsUrl') },
        {title: "onsale", icon:"list", listType: Global.ON_SALE, url: InternationalizationHelper.getString('onSaleUrl') },
        {title: "charts", icon:"list", listType: Global.CHARTS, url: "charts" },
        {title: "allMusic", icon:"list", listType:Global.AZ, url: InternationalizationHelper.getString('allMusicUrl')},
        {title: "greatestHits", icon:"list", listType:Global.GREATESTHITS, url: "/greatest-hits"},
            { title: "newOnAppleMusic", icon: "list", listType: Global.RECENTLYADDED, url: InternationalizationHelper.getString('newOniTunesUrl') }]
        },

      {title:"ebooks", color:"purple", mediaType:Global.EBOOKS,
      items: [
        {title: 'blackFriday', icon:'list', listType: Global.BLACK_FRIDAY, url:InternationalizationHelper.getString('blackFridayDealsUrl') },
        {title: "onsale", icon:"list", listType: Global.ON_SALE, url: InternationalizationHelper.getString('onSaleUrl') },
        {title: "charts", icon:"list", listType: Global.CHARTS, url: "charts" },
        {title: "allEbooks", icon:"list", listType:Global.AZ, url: InternationalizationHelper.getString('allBooksUrl')},
        {title: "currentlyForFree", icon:"list", listType:Global.NOW_FREE, url: InternationalizationHelper.getString('nowFreeUrl')},
            { title: "newOnAppleBooks", icon: "list", listType: Global.RECENTLYADDED, url: InternationalizationHelper.getString('newOniTunesUrl') }]
        },

      {title:"audiobooks", color:"mint", mediaType:Global.AUDIOBOOKS,
      items: [
        {title: 'blackFriday', icon:'list', listType: Global.BLACK_FRIDAY, url:InternationalizationHelper.getString('blackFridayDealsUrl') },
        {title: "onsale", icon:"list", listType: Global.ON_SALE, url: InternationalizationHelper.getString('onSaleUrl') },
        {title: "charts", icon:"list", listType: Global.CHARTS, url: "charts" },
        {title: "allAudiobooks", icon:"list", listType:Global.AZ, url: InternationalizationHelper.getString('allAudiobooksUrl')},
          { title: "newOnAppleBooks", icon: "list", listType: Global.RECENTLYADDED, url: InternationalizationHelper.getString('newOniTunesUrl') }]
      }
      ]
    },
    {
      store: Global.AMAZON, categories:
      [
        {
          title:"movies", color:"red", mediaType:Global.BUYMOVIES,
          items: [
            {title: 'blackFriday', icon:'list', listType: Global.BLACK_FRIDAY, url:InternationalizationHelper.getString('blackFridayDealsUrl') },
            {title: "onsale", icon:"list", listType: Global.ON_SALE, url: InternationalizationHelper.getString('onSaleUrl') },
            {title: "charts", icon:"list", listType: Global.CHARTS, url: "charts" },
            {title: "allMovies", icon:"list", listType: Global.AZ, url: InternationalizationHelper.getString('allMoviesUrl')},
            {
              title: "newOnPrimeVideo",
              icon: "list",
              listType: Global.NEW_ON_PRIME_VIDEO,
              url: InternationalizationHelper.getString('newOnPrimeVideoUrl')
            },
          ]
        },
        {
          title:"seasons", color:"green", mediaType:Global.SEASONS,
          items: [
            {title: 'blackFriday', icon:'list', listType: Global.BLACK_FRIDAY, url:InternationalizationHelper.getString('blackFridayDealsUrl') },
            {title: "onsale", icon:"list", listType: Global.ON_SALE, url: InternationalizationHelper.getString('onSaleUrl') },
            {title: "charts", icon:"list", listType: Global.CHARTS, url: "charts" },
            {title: "allSeasons", icon:"list", listType:Global.AZ, url: InternationalizationHelper.getString('allSeasonsUrl')},
          ]
        }
        ]
    },
    {
      store: Global.VUDU, categories:
      [
        {
          title:"movies", color:"red", mediaType:Global.BUYMOVIES,
          items: [
            {title: 'blackFriday', icon:'list', listType: Global.BLACK_FRIDAY, url:InternationalizationHelper.getString('blackFridayDealsUrl') },
            {title: "onsale", icon:"list", listType: Global.ON_SALE, url: InternationalizationHelper.getString('onSaleUrl') },
            {title: "charts", icon:"list", listType: Global.CHARTS, url: "charts" },
            {title: "movieBundles", icon:"list", listType:Global.BUNDLES, url: InternationalizationHelper.getString('onSaleUrl') },
            {title: "allMovies", icon:"list", listType: Global.AZ, url: InternationalizationHelper.getString('allMoviesUrl')},
            // { title: "top200", icon: "list", listType: Global.TOP_200, url: "top-200" }, // Temporarily disabled
            { title: "comingSoon", icon: "list", listType: Global.COMING_SOON, url: "coming-soon" },
            { title: "newReleases", icon: "list", listType: Global.NEW_RELEASES, url: "new-releases" },
            { title: "newMovies", icon: "list", listType: Global.NEW_MOVIES, url: "new-movies" },
            { title: "movies4K", icon: "list", listType: Global.MOVIES_IN_4K, url: "4k" },
            { title: "newTo4k", icon: "list", listType: Global.NEW_TO_4K, url: "new-to-4k" },
          ]
          },
          {
            title: "seasons", color: "green", mediaType: Global.SEASONS,
            items: [
              { title: 'blackFriday', icon: 'list', listType: Global.BLACK_FRIDAY, url: InternationalizationHelper.getString('blackFridayDealsUrl') },
              { title: "onsale", icon: "list", listType: Global.ON_SALE, url: InternationalizationHelper.getString('onSaleUrl') },
              { title: "charts", icon: "list", listType: Global.CHARTS, url: "charts" },
              { title: "tvBundles", icon: "list", listType: Global.BUNDLES, url: InternationalizationHelper.getString('seasonsBundlesUrl') },
              { title: "allSeasons", icon: "list", listType: Global.AZ, url: InternationalizationHelper.getString('allSeasonsUrl') },
              { title: "newSeasons", icon: "list", listType: Global.NEW_SEASONS, url: "new-seasons" },
              { title: "seasons4K", icon: "list", listType: Global.SEASONS_IN_4K, url: "4k-seasons" },
              { title: "classicSeasons", icon: "list", listType: Global.CLASSIC_SEASONS, url: "classic-seasons" },
            ]
        }
        ]
    },
    {
      store: Global.GOOGLEPLAY, categories:
      [
        {
          title:"movies", color:"red", mediaType:Global.BUYMOVIES,
          items: [
            {title: 'blackFriday', icon:'list', listType: Global.BLACK_FRIDAY, url:InternationalizationHelper.getString('blackFridayDealsUrl') },
            {title: "onsale", icon:"list", listType: Global.ON_SALE, url: InternationalizationHelper.getString('onSaleUrl') },
            {title: "allMovies", icon:"list", listType: Global.AZ, url: InternationalizationHelper.getString('allMoviesUrl')},
          ]
        }
        ]
    }
  ];

}
